"use client"
import ScrollContainer from '@web-libs/ui/layout-components/scroll-container/scroll-container';
import {Logo} from '@web-libs/features/branding/logo/ui/logo';
import {CSSProperties} from 'react';
import { useTenant } from '@web-libs/core/context/tenant-context';

export const LegalPage = ({titleText, type}: { titleText: string, type: 'privacyPolicy' | 'imprint' }) => {
    const style: CSSProperties = {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
    };

    const tenant = useTenant()

    return (
        <main style={style}>
            <ScrollContainer>
                <div style={{padding: 20}}>
                    <Logo></Logo>
                    <h1 style={{marginBottom: 40}}>{titleText}</h1>
                    <div dangerouslySetInnerHTML={{__html: type === 'privacyPolicy' ? tenant.privacyPolicy : tenant.imprint}}/>
                </div>
            </ScrollContainer>
        </main>
    );
};
